import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/leden",
    name: "members.index",
    component: () => import("@/modules/members/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
